export default __webpack_public_path__ + "static/ThinkstockPhotos-514928156_article-0c58f9abc74c7e50f1f8cd539e9b3055.jpg";